import { useState } from "react"
import styled from "styled-components"

import { spacing, Text } from "@minuthq/meatball-ui-react"

import { TaskList } from "src/components/TaskManagement/TaskList"
import { TaskStatusDropdown } from "src/components/TaskManagement/TaskStatusDropdown"
import { TTask } from "src/data/taskManagement/taskManagementTypes"
import { useTranslate } from "src/i18n/useTranslate"

export function TaskListViewTab() {
  const { t, langKeys } = useTranslate()

  const [selectedStatus, setSelectedStatus] = useState<TTask["status"]>("todo")

  return (
    <div>
      <HeaderBox>
        <Text variant="heading2">
          {t(langKeys.task_management_task_list_title)}
        </Text>

        <TaskStatusDropdown
          currentStatus={selectedStatus}
          onChange={setSelectedStatus}
        />
      </HeaderBox>

      <TaskList taskStatus={selectedStatus} />
    </div>
  )
}

const HeaderBox = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.L};
  flex-wrap: wrap;
  margin-bottom: ${spacing.M};
`
